import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalInvoiceUpdateProps {}

const ModalInvoiceUpdate = ({}: ModalInvoiceUpdateProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.updateInvoice');
  const onClose = () => {
    closeSingleModal('updateInvoice');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Atualizar invoice"
      height={'auto'}
      width={'60vw'}
      backgroundColor={'#ececec'}
    >
      <Form.Export.Invoice.Update />
    </Modal>
  );
};

export default ModalInvoiceUpdate;
